
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'aipb-inside-loading',
  template: `
    @if (loading) {
      <div class="loading-container" @loadingTrigger>
        <mat-spinner [diameter]="diameter"></mat-spinner>
      </div>
    }
    `,
  styleUrls: ['./inside-loading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatProgressSpinnerModule],
  animations: [
    trigger('loadingTrigger', [
      transition(':enter', [style({ opacity: 0 }), animate('300ms', style({ opacity: 1 }))]),
      transition(':leave', [animate('300ms', style({ opacity: 0 }))])
    ])
  ]
})
export class InsideLoadingComponent {
  @Input() loading = false;
  @Input() diameter = 50;
}
